<template lang="pug" src="./options-dialog.pug"></template>
<style lang="scss" src="./options-dialog.scss" scoped></style>

<script>

export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        options: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        existingOptions: []
    }),
    computed: {
        optionsDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        allOptionsFilled() {
            return this.options.length === 0 || this.options.every(it => !!it);
        }
    },
    watch: {
        optionsDialog(val) {
            if (val) {
                this.existingOptions = this.options.slice();
            }
        }
    },
    methods: {
        onInput(value, index) {
            this.$set(this.options, index, value);
        },
        addOption() {
            this.options.push('');
        },
        removeOption(index) {
            this.options.splice(index, 1);
        },
        saveOptions() {
            this.optionsDialog = false;
            this.emitOptions();
        },
        emitOptions(options) {
            this.$emit('optionsChange', options || this.options);
        },
        closeDialog() {
            // if dialog was closed - need to return existing component options
            this.emitOptions(this.existingOptions);
            this.optionsDialog = false;
        }
    }
};
</script>
